export default __webpack_public_path__ + "static/media/soRekt_dark.5eed5c82.svg";